import { getAuth, signOut } from 'firebase/auth';
import Cookie from 'universal-cookie';
import { unSubMeta } from './useUserChanged';
import firebase from '@/plugins/firebaseConfig';

const cookie = new Cookie();
const auth = getAuth(firebase);

export const useLogout = () => {
  const logout = async () => {
    if (unSubMeta) {
      unSubMeta();
    }
    await signOut(auth);
    cookie.remove('token');
  };

  return { logout };
};
